import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _sizes$lg, _sizes$md, _types$payment, _sizes$lg2, _sizes$md2, _types$wallet, _systems$google, _sizes$lg3, _sizes$md3, _types$payment2, _sizes$lg4, _sizes$md4, _types$wallet2, _systems$apple, _sizes$lg5, _sizes$md5, _types$payment3, _mapIcons;

import React from 'react';
import { ApplePayLightLen, ApplePayLightLru, ApplePayLightS, AppleWalletLightLen, AppleWalletLightLru, AppleWalletLightSen, AppleWalletLightSru, DolyameLightLen, DolyameLightLru, DolyameLightXsru, DolyameWalletLen, GooglePayLightLen, GooglePayLightLru, GoogleWalletLightLen, GoogleWalletLightLru, GoogleWalletLightS, GoogleWalletLightXs } from "../icons";
export var themes = {
  black: 'black',
  white: 'white'
};
export var systems = {
  google: 'google',
  apple: 'apple',
  dolyame: 'dolyame'
};
export var types = {
  payment: 'payment',
  wallet: 'wallet'
};
export var sizes = {
  lg: 'lg',
  md: 'md'
};
export var langs = {
  ru: 'ru',
  en: 'en'
};
export var mapIcons = (_mapIcons = {}, _defineProperty(_mapIcons, systems.google, (_systems$google = {}, _defineProperty(_systems$google, types.payment, (_types$payment = {}, _defineProperty(_types$payment, sizes.lg, (_sizes$lg = {}, _defineProperty(_sizes$lg, langs.ru, /*#__PURE__*/React.createElement(GooglePayLightLru, null)), _defineProperty(_sizes$lg, langs.en, /*#__PURE__*/React.createElement(GooglePayLightLen, null)), _defineProperty(_sizes$lg, "compact", /*#__PURE__*/React.createElement(GoogleWalletLightS, null)), _sizes$lg)), _defineProperty(_types$payment, sizes.md, (_sizes$md = {}, _defineProperty(_sizes$md, langs.ru, /*#__PURE__*/React.createElement(GooglePayLightLru, {
  width: 166,
  height: 19
})), _defineProperty(_sizes$md, langs.en, /*#__PURE__*/React.createElement(GooglePayLightLen, {
  width: 111,
  height: 26
})), _defineProperty(_sizes$md, "compact", /*#__PURE__*/React.createElement(GoogleWalletLightXs, null)), _sizes$md)), _types$payment)), _defineProperty(_systems$google, types.wallet, (_types$wallet = {}, _defineProperty(_types$wallet, sizes.lg, (_sizes$lg2 = {}, _defineProperty(_sizes$lg2, langs.ru, /*#__PURE__*/React.createElement(GoogleWalletLightLru, null)), _defineProperty(_sizes$lg2, langs.en, /*#__PURE__*/React.createElement(GoogleWalletLightLen, null)), _sizes$lg2)), _defineProperty(_types$wallet, sizes.md, (_sizes$md2 = {}, _defineProperty(_sizes$md2, langs.ru, /*#__PURE__*/React.createElement(GoogleWalletLightLru, null)), _defineProperty(_sizes$md2, langs.en, /*#__PURE__*/React.createElement(GoogleWalletLightLen, null)), _sizes$md2)), _types$wallet)), _systems$google)), _defineProperty(_mapIcons, systems.apple, (_systems$apple = {}, _defineProperty(_systems$apple, types.payment, (_types$payment2 = {}, _defineProperty(_types$payment2, sizes.lg, (_sizes$lg3 = {}, _defineProperty(_sizes$lg3, langs.ru, /*#__PURE__*/React.createElement(ApplePayLightLru, {
  width: 143,
  height: 22
})), _defineProperty(_sizes$lg3, langs.en, /*#__PURE__*/React.createElement(ApplePayLightLen, {
  width: 119,
  height: 22
})), _defineProperty(_sizes$lg3, "compact", /*#__PURE__*/React.createElement(ApplePayLightS, null)), _sizes$lg3)), _defineProperty(_types$payment2, sizes.md, (_sizes$md3 = {}, _defineProperty(_sizes$md3, langs.ru, /*#__PURE__*/React.createElement(ApplePayLightLru, {
  width: 125,
  height: 20
})), _defineProperty(_sizes$md3, langs.en, /*#__PURE__*/React.createElement(ApplePayLightLen, {
  width: 104,
  height: 20
})), _defineProperty(_sizes$md3, "compact", /*#__PURE__*/React.createElement(ApplePayLightS, null)), _sizes$md3)), _types$payment2)), _defineProperty(_systems$apple, types.wallet, (_types$wallet2 = {}, _defineProperty(_types$wallet2, sizes.lg, (_sizes$lg4 = {}, _defineProperty(_sizes$lg4, langs.ru, {
  base: /*#__PURE__*/React.createElement(AppleWalletLightLru, {
    width: 225,
    height: 24
  }),
  compact: /*#__PURE__*/React.createElement(AppleWalletLightSru, {
    width: 135,
    height: 28
  })
}), _defineProperty(_sizes$lg4, langs.en, {
  base: /*#__PURE__*/React.createElement(AppleWalletLightLen, {
    width: 188,
    height: 24
  }),
  compact: /*#__PURE__*/React.createElement(AppleWalletLightSen, {
    width: 124,
    height: 28
  })
}), _sizes$lg4)), _defineProperty(_types$wallet2, sizes.md, (_sizes$md4 = {}, _defineProperty(_sizes$md4, langs.ru, {
  base: /*#__PURE__*/React.createElement(AppleWalletLightLru, {
    width: 221,
    height: 21
  }),
  compact: /*#__PURE__*/React.createElement(AppleWalletLightSru, {
    width: 109,
    height: 21
  })
}), _defineProperty(_sizes$md4, langs.en, {
  base: /*#__PURE__*/React.createElement(AppleWalletLightLen, {
    width: 184,
    height: 24
  }),
  compact: /*#__PURE__*/React.createElement(AppleWalletLightSen, {
    width: 99,
    height: 21
  })
}), _sizes$md4)), _types$wallet2)), _systems$apple)), _defineProperty(_mapIcons, systems.dolyame, _defineProperty({}, types.payment, (_types$payment3 = {}, _defineProperty(_types$payment3, sizes.lg, (_sizes$lg5 = {}, _defineProperty(_sizes$lg5, langs.ru, {
  base: /*#__PURE__*/React.createElement(DolyameLightLru, {
    width: 165,
    height: 19
  }),
  compact: /*#__PURE__*/React.createElement(DolyameLightXsru, null)
}), _defineProperty(_sizes$lg5, langs.en, {
  base: /*#__PURE__*/React.createElement(DolyameWalletLen, null),
  compact: /*#__PURE__*/React.createElement(DolyameLightXsru, null)
}), _sizes$lg5)), _defineProperty(_types$payment3, sizes.md, (_sizes$md5 = {}, _defineProperty(_sizes$md5, langs.ru, {
  base: /*#__PURE__*/React.createElement(DolyameLightLru, {
    width: 158,
    height: 16
  }),
  compact: /*#__PURE__*/React.createElement(DolyameLightXsru, null)
}), _defineProperty(_sizes$md5, langs.en, {
  base: /*#__PURE__*/React.createElement(DolyameLightLen, null),
  compact: /*#__PURE__*/React.createElement(DolyameLightXsru, null)
}), _sizes$md5)), _types$payment3))), _mapIcons);